/* eslint-disable sort-keys */
import React from 'react';

import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import { uiRoutes } from '@consumer-frontend/nc-api';
import {
  NcContract,
  NcGenericErrorPage,
  NcMakeAPayment,
  NcMessageCenter,
  NcMessageDetail,
  NcNotFoundErrorPage,
  NcPaymentConfirmation,
  NcPaymentError,
  NcRequestCashAdvanceConfirmationPage,
  NcRequestCashAdvancePage,
  NcRequestCashAdvanceReviewPage,
  NcRequestCashAdvanceRouter,
} from '@consumer-frontend/nc-components';

import { HomePage } from './HomePage';
import { RootPage } from './RootPage';

export const App = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <RootPage />,
      errorElement: <NcGenericErrorPage />,
      children: [
        {
          errorElement: <NcGenericErrorPage />,
          children: [
            // Home page (currently redirects to Message Center)
            {
              index: true,
              path: '',
              element: <HomePage />,
            },

            // Contract page
            { path: uiRoutes.dashboard.contract, element: <NcContract /> },

            // Make-a-Payment pages
            { path: uiRoutes.dashboard.makeAPayment, element: <NcMakeAPayment /> },
            { path: uiRoutes.dashboard.paymentConfirmation, element: <NcPaymentConfirmation /> },
            { path: uiRoutes.dashboard.paymentError, element: <NcPaymentError /> },

            // Message Center pages
            { path: uiRoutes.dashboard.messages, element: <NcMessageCenter /> },
            { path: uiRoutes.dashboard.messageDetail, element: <NcMessageDetail /> },

            // Request Cash Advance pages
            {
              path: uiRoutes.dashboard.requestCashAdvance,
              element: <NcRequestCashAdvanceRouter />,
              children: [
                { index: true, element: <NcRequestCashAdvancePage /> },
                {
                  path: uiRoutes.dashboard.requestCashAdvanceReview,
                  element: <NcRequestCashAdvanceReviewPage />,
                },
                {
                  path: uiRoutes.dashboard.requestCashAdvanceConfirmation,
                  element: <NcRequestCashAdvanceConfirmationPage />,
                },
              ],
            },

            // Fallback for unmatched routes => 404 Page
            { path: uiRoutes.dashboard.notFound, element: <NcNotFoundErrorPage /> },
            { path: '*', element: <Navigate to={uiRoutes.dashboard.notFound} /> },
          ],
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};
